export default "__VITE_ASSET__DqHw9ok1__"